import React from 'react'
import PropTypes from 'prop-types'

class Instructors extends React.Component {
  render() {
    return(
      <tr>
        <th className={this.props.fieldClassName}>
          {this.props.fieldName}
        </th>
        <td>
					{this.props.instructors.map ((instructor, index) =>
						<a className='styled-link pointer-hand'
							href={"/users/" + instructor.user.id}
							key={instructor.id}
						>
							{instructor.user.first_name + " " + instructor.user.last_name}
              {index+1 !== this.props.instructorsLength ? "," : ""}&nbsp;
						</a>
					)}
        </td>
      </tr>
    )
  }
}

Instructors.propTypes = {
  fieldName: PropTypes.string,
  instructors: PropTypes.array,
  instructorsLength: PropTypes.number,
  fieldClassName: PropTypes.string
}

export default Instructors
